// pre-specified collections of bills: house passed, senate passed, signed ...
import Navigator from 'app';
const BillListCollection = Backbone.Collection.extend({
  model: Backbone.Model.extend(),
  url: Navigator.config.api_base + 'bills/'
});
const API = {
  getBillList: function (list) {
    var defer = $.Deferred();
    const bills = new BillListCollection();
    bills.url += list;
    bills.fetch({
      success: function (data) {
        defer.resolve(data);
      },
      error: function (error) {
        defer.reject(error);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("bill:list", function (list) {
  return API.getBillList(list);
});
export { BillListCollection as default };